import { action, Action } from 'typesafe-actions'

import {
  PropostaTypes,
  PropostaApi,
  DadosPropostaPayload,
  GetPropostasPayload,
  PropostasResponse,
  DocumentosEnvioType,
} from './types'

export const dadosPropostaRequest = (): Action => action(PropostaTypes.DADOS_PROPOSTA_REQUEST)

export const dadosPropostaSucess = (payload: PropostaApi): Action =>
  action(PropostaTypes.DADOS_PROPOSTA_SUCCESS, payload)

export const dadosPropostaError = (): Action => action(PropostaTypes.DADOS_PROPOSTA_ERROR)

export const setTipoDocumento = (payload: DocumentosEnvioType[]): Action =>
  action(PropostaTypes.SET_TIPO_DOCUMENTO, payload)

export const setIdIteracao = (payload: string): Action =>
  action(PropostaTypes.SET_ID_ITERACAO, payload)

export const dadosPropostaAntigaRequest = (payload?: DadosPropostaPayload): Action =>
  action(PropostaTypes.DADOS_PROPOSTA_ANTIGA_REQUEST, payload)

export const dadosPropostaAntigaSucess = (payload: PropostaApi): Action =>
  action(PropostaTypes.DADOS_PROPOSTA_ANTIGA_SUCCESS, payload)

export const dadosPropostaAntigaError = (): Action =>
  action(PropostaTypes.DADOS_PROPOSTA_ANTIGA_ERROR)

export const getPropostasRequest = (payload: GetPropostasPayload): Action =>
  action(PropostaTypes.GET_PROPOSTAS_REQUEST, payload)

export const getPropostasSuccess = (payload: PropostasResponse): Action =>
  action(PropostaTypes.GET_PROPOSTAS_SUCCESS, payload)

export const getPropostasError = (): Action => action(PropostaTypes.GET_PROPOSTAS_ERROR)
